import { __makeTemplateObject } from "tslib";
import styled from '@emotion/styled';
import React from 'react';
var StyledTabPanel = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 100%;\n"], ["\n  height: 100%;\n"])));
export var TabPanel = function (_a) {
    var children = _a.children, value = _a.value, index = _a.index, _b = _a.id, id = _b === void 0 ? '' : _b;
    return (React.createElement(StyledTabPanel, { id: "tabpanel-" + index + "_" + id, role: "tabpanel", hidden: value !== index }, value === index && children));
};
var templateObject_1;
